<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="unidades" v-model="unidadeSelecionada" item-text="descricao_unidade"
                            item-value="id_unidade" :label="$t('nav.registration.units')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="linhas" v-model="linhaSelecionada" item-text="nome_linha"
                            item-value="id_linha" :label="$t('candidateReservations.headers.line')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="turnos" v-model="turnoSelecionado" item-text="descricao_turno"
                            item-value="id_turno" :label="$t('candidateReservations.headers.shift')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="statusOptions" v-model="statusSelecionado" item-text="text"
                            item-value="value" :label="$t('candidateReservations.headers.status')" clearable />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="tableHeaders" :items="reservas" :loading="loading"
            :loading-text="$t('candidateReservations.report.loading')"
            cod-tabela="RESERVASCANDIDATOS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('candidateReservations.report.title')" :token="token" :items="reservas"
                    csv-title="reservascandidatos" :pdf-title="$t('candidateReservations.report.title')"
                    :pdf-headers="tableHeaders" pdf-filename="reservascandidatos" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <template v-if="item.status === 'ATIVA'">
                    <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                    <v-icon small class="mr-2" color="red" @click="confirmCancelarReserva(item)" :disabled="!canDelete">mdi-delete</v-icon>
                </template>
            </template>
        </MerusDataTable>

        <v-dialog v-model="editDialog" persistent max-width="600px">
            <v-card>
                <v-card-title style="color: #4a4a4a">{{ $t('candidateReservations.dialog.title') }}</v-card-title>
                <v-card-text>
                    <div v-if="reservaEditItem" class="mb-3">
                        <strong>{{ reservaEditItem.nome_candidato }}</strong>
                    </div>
                    <v-form ref="formReserva" v-model="formReservaValidado">
                        <v-select v-model="reservaLinhaSelected" :items="reservaLinhas" item-text="nome_linha"
                            item-value="id_linha" :label="$t('candidateReservations.dialog.line')" clearable
                            @change="onReservaLinhaChange" />
                        <v-select v-model="reservaTurnoSelected" :items="reservaTurnosFiltrados"
                            item-text="descricao_turno" item-value="id_turno"
                            :label="$t('candidateReservations.dialog.shift')" clearable />
                        <v-select v-model="reservaCercaSelected" :items="reservaCercasFiltradas" item-text="nome_cerca"
                            item-value="id_cerca" :label="$t('candidateReservations.dialog.fence')" clearable />
                        <v-subheader class="px-0">{{ $t('candidateReservations.headers.expiresAt') }}</v-subheader>
                        <v-datetime-picker v-model="reservaDataHoraSelected"
                            :key="reservaEditPickerKey"
                            :label="$t('candidateReservations.headers.expiresAt')"
                            :time-picker-props="timeProps" :text-field-props="reservaExpiracaoTextFieldProps"
                            :date-picker-props="dtExpiracaoProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')" @input="onReservaDataHoraChange">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="white--text" :disabled="!canSaveReservaEdit"
                        @click="salvarReservaEditada">
                        {{ $t('button.save') }}
                    </v-btn>
                    <v-btn color="primary" class="white--text" @click="closeEditDialog">{{ $t('button.close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span style="color: #d60000">{{ $t('system.alert') }}</span>
                </v-card-title>
                <v-card-text>
                    <span style="color: #d60000">{{ mensagemDialog }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="executarConfirmacao">
                        {{ $t('button.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="reservaConfirmNoCapacityDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span style="color: #d60000">{{ $t('system.alert') }}</span>
                </v-card-title>
                <v-card-text>
                    <span style="color: #d60000">{{ $t('candidateReservations.dialog.confirmNoCapacity') }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="reservaConfirmNoCapacityDialog = false">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="confirmarReservaSemCapacidade">
                        {{ $t('button.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import DateUtils from '@/utils/dateutils';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

const RESERVA_DIAS = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        headers: [],
        user: null,
        token: null,
        recursos: [],
        canEdit: false,
        canDelete: false,
        formValidado: false,
        formReservaValidado: false,
        unidades: [],
        linhas: [],
        turnos: [],
        unidadeSelecionada: null,
        linhaSelecionada: null,
        turnoSelecionado: null,
        statusSelecionado: null,
        reservas: [],
        loading: false,
        editDialog: false,
        reservaEditItem: null,
        reservaLinhas: [],
        reservaLinhaSelected: null,
        reservaTurnoSelected: null,
        reservaCercaSelected: null,
        reservaCercas: [],
        reservaDataHoraSelected: null,
        reservaEditPickerKey: 0,
        timeProps: {
            useSeconds: true,
        },
        confirmDialog: false,
        mensagemDialog: '',
        confirmCallback: null,
        reservaConfirmNoCapacityDialog: false,
    }),
    computed: {
        tableHeaders() {
            const base = this.headers && this.headers.length ? this.headers : [];
            const hasActions = base.some((h) => h.value === 'actions');
            if (hasActions) return base;
            return base.concat([{
                text: this.$t('crud.headers.actions'),
                value: 'actions',
                sortable: false,
                filtrable: false,
            }]);
        },
        statusOptions() {
            return [
                { text: this.$t('candidateReservations.status.active'), value: 'ATIVA' },
                { text: this.$t('candidateReservations.status.confirmed'), value: 'CONFIRMADA' },
                { text: this.$t('candidateReservations.status.cancelled'), value: 'CANCELADA' },
                { text: this.$t('candidateReservations.status.expired'), value: 'EXPIRADA' },
            ];
        },
        reservaTurnosFiltrados() {
            if (!this.reservaEditItem || !this.reservaEditItem.id_unidade) {
                return this.turnos;
            }
            return this.turnos.filter(
                (t) => t.id_unidade == null || String(t.id_unidade) === String(this.reservaEditItem.id_unidade)
            );
        },
        reservaCercasFiltradas() {
            if (!this.reservaLinhaSelected) {
                return [];
            }
            return (this.reservaCercas || []).filter(
                (c) => String(c.id_linha) === String(this.reservaLinhaSelected)
            );
        },
        canSaveReservaEdit() {
            return this.canEdit && this.reservaEditItem && this.reservaLinhaSelected
                && this.reservaTurnoSelected && this.reservaDataHoraSelected;
        },
        dtExpiracaoProps() {
            return {
                min: new Date().toISOString().substring(0, 10),
            };
        },
        reservaExpiracaoTextFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
                rules: [
                    () => !!this.reservaDataHoraSelected || this.$t('contract.messages.selectDate'),
                    () => {
                        const d = this.reservaDataHoraSelected;
                        if (!d) return true;
                        if (!(d instanceof Date) || isNaN(d.getTime())) {
                            return this.$t('contract.messages.selectDate');
                        }
                        return d > new Date() || this.$t('contract.messages.selectDate');
                    },
                ],
            };
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.populaRecursos();
        this.populaUnidades();
        this.populaLinhas();
        this.populaTurnos();
        this.populaRelatorio();
    },
    methods: {
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data || [];
                        this.canEdit = true;
                        this.canDelete = true;
                    },
                });
                return;
            }
            apiController.request(apiController.endpoints.getRecursosusuario, {
                params: { id: this.user.id_usuario },
                onSuccess: (response) => {
                    this.recursos = response.data || [];
                    this.canEdit = this.recursos.some((r) =>
                        r.rota === '/api/v1.0/insertreservacandidato' || r.rota === '/api/v1.0/updatereservacandidato'
                    );
                    this.canDelete = this.recursos.some((r) => r.rota === '/api/v1.0/cancelarreservacandidato');
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidades, {
                onSuccess: (response) => {
                    this.unidades = response.data || [];
                },
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                },
            });
        },
        populaTurnos() {
            apiController.request(apiController.endpoints.getallTurnos, {
                onSuccess: (response) => {
                    this.turnos = response.data || [];
                },
            });
        },
        populaRelatorio() {
            this.loading = true;
            const query = {};
            if (this.unidadeSelecionada) query.id_unidade = this.unidadeSelecionada;
            if (this.linhaSelecionada) query.id_linha = this.linhaSelecionada;
            if (this.turnoSelecionado) query.id_turno = this.turnoSelecionado;
            if (this.statusSelecionado) query.status = this.statusSelecionado;
            apiController.request(apiController.endpoints.getReservascandidatos, {
                query,
                onSuccess: (response) => {
                    this.reservas = response.data || [];
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                },
            });
        },
        confirmCancelarReserva(item) {
            this.mensagemDialog = this.$t('candidateReservations.dialog.cancel') + '?';
            this.confirmCallback = () => this.cancelarReserva(item);
            this.confirmDialog = true;
        },
        executarConfirmacao() {
            this.confirmDialog = false;
            if (this.confirmCallback) {
                this.confirmCallback();
            }
            this.confirmCallback = null;
        },
        cancelarReserva(item) {
            apiController.request(apiController.endpoints.cancelarreservacandidato, {
                data: { id_reserva: item.id_reserva },
                onSuccess: (response) => {
                    if (response.data.erro) {
                        EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
                    } else {
                        EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' });
                        this.populaRelatorio();
                    }
                },
            });
        },
        editItem(item) {
            if (!this.canEdit || item.status !== 'ATIVA') return;
            this.reservaEditItem = { ...item };
            this.reservaLinhaSelected = item.id_linha;
            this.reservaTurnoSelected = item.id_turno;
            this.reservaCercaSelected = item.id_cerca || null;
            this.reservaDataHoraSelected = this.parseReservaDataHora(item.dt_expiracao);
            this.reservaEditPickerKey += 1;
            this.editDialog = true;
            this.loadReservaEditData();
            this.$nextTick(() => {
                if (this.$refs.formReserva) {
                    this.$refs.formReserva.resetValidation();
                }
            });
        },
        onReservaDataHoraChange() {
            this.$nextTick(() => {
                if (this.$refs.formReserva) {
                    this.$refs.formReserva.validate();
                }
            });
        },
        parseReservaDataHora(dt) {
            if (!dt) return null;
            const d = new Date(dt);
            return isNaN(d.getTime()) ? null : d;
        },
        formatReservaDataHoraParaApi(date) {
            return DateUtils.getDateSQLFormatted(date);
        },
        closeEditDialog() {
            this.editDialog = false;
            this.reservaConfirmNoCapacityDialog = false;
            this.reservaEditItem = null;
            this.reservaLinhas = [];
            this.reservaCercas = [];
            this.reservaLinhaSelected = null;
            this.reservaTurnoSelected = null;
            this.reservaCercaSelected = null;
            this.reservaDataHoraSelected = null;
        },
        loadReservaEditData() {
            if (!this.reservaEditItem || !this.reservaEditItem.id_unidade) return;
            const idUnidade = this.reservaEditItem.id_unidade;
            (async () => {
                try {
                    const [linhasRes, cercasRes] = await Promise.all([
                        apiController.request(apiController.endpoints.getLinhasassociadas, {
                            data: [idUnidade],
                            silent: true,
                        }),
                        apiController.request(apiController.endpoints.getCercasvalidacaocandidato, {
                            params: { id: idUnidade },
                            silent: true,
                        }),
                    ]);
                    this.reservaLinhas = linhasRes.data || [];
                    this.reservaCercas = cercasRes.data || [];
                } catch (e) {
                    EventBus.$emit('show-error', { error: e });
                }
            })();
        },
        onReservaLinhaChange() {
            this.reservaCercaSelected = null;
        },
        maxAssentosDisponiveisRow(row) {
            if (row.assentos_disponiveis_max != null && !isNaN(Number(row.assentos_disponiveis_max))) {
                return Number(row.assentos_disponiveis_max);
            }
            let max = 0;
            for (const dia of RESERVA_DIAS) {
                const v = Number(row['assentos_disponiveis_' + dia]);
                if (!isNaN(v) && v > max) {
                    max = v;
                }
            }
            return max;
        },
        lineTurnoHasVaga() {
            if (!this.reservaLinhaSelected || !this.reservaTurnoSelected) {
                return null;
            }
            const rows = (this.reservaCercas || []).filter(
                (row) =>
                    String(row.id_linha) === String(this.reservaLinhaSelected) &&
                    String(row.id_turno_linha) === String(this.reservaTurnoSelected)
            );
            if (!rows.length) {
                return null;
            }
            return rows.some((row) => this.maxAssentosDisponiveisRow(row) > 0);
        },
        handleReservaInsertError(responseData, ignorarCapacidade) {
            if (responseData && responseData.code === 'noCapacity' && !ignorarCapacidade) {
                this.reservaConfirmNoCapacityDialog = true;
                return true;
            }
            if (responseData && responseData.erro) {
                EventBus.$emit('show-alert', { mensagem: responseData.mensagem, tipo: 'error' });
                return true;
            }
            return false;
        },
        confirmarReservaSemCapacidade() {
            this.reservaConfirmNoCapacityDialog = false;
            this.salvarReservaEditada(true);
        },
        salvarReservaEditada(ignorarCapacidade = false) {
            if (!this.canSaveReservaEdit) return;
            this.$refs.formReserva.validate();
            if (!this.formReservaValidado) return;

            const item = this.reservaEditItem;
            const dtExpiracao = this.formatReservaDataHoraParaApi(this.reservaDataHoraSelected);
            const payload = {
                id_reserva: item.id_reserva,
                id_linha: this.reservaLinhaSelected,
                id_turno: this.reservaTurnoSelected,
                id_cerca: this.reservaCercaSelected,
                id_unidade: item.id_unidade,
                dt_expiracao: dtExpiracao,
                ignorarCapacidade,
            };
            const dtExpiracaoAtual = this.formatReservaDataHoraParaApi(this.parseReservaDataHora(item.dt_expiracao));
            const unchanged =
                String(item.id_linha) === String(payload.id_linha) &&
                String(item.id_turno) === String(payload.id_turno) &&
                String(item.id_cerca || '') === String(payload.id_cerca || '') &&
                dtExpiracaoAtual === dtExpiracao;
            if (unchanged) {
                this.closeEditDialog();
                return;
            }
            const linhaTurnoAlterados =
                String(item.id_linha) !== String(payload.id_linha) ||
                String(item.id_turno) !== String(payload.id_turno);
            const hasVaga = this.lineTurnoHasVaga();
            if (!ignorarCapacidade && linhaTurnoAlterados && hasVaga === false) {
                this.reservaConfirmNoCapacityDialog = true;
                return;
            }
            apiController.request(apiController.endpoints.updateReservacandidato, {
                data: payload,
                silent: true,
                onSuccess: (response) => {
                    if (response.data.erro) {
                        this.handleReservaInsertError(response.data, ignorarCapacidade);
                    } else {
                        EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' });
                        this.closeEditDialog();
                        this.populaRelatorio();
                    }
                },
                onError: (e) => {
                    const data = e.response && e.response.data;
                    if (!this.handleReservaInsertError(data, ignorarCapacidade)) {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
    },
};
</script>
